<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data.value" placeholder="请选择"
             @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in deviceType" :key="index"></el-option>
  </el-select>
</template>

<script>
    import { EditionfindPage } from "@/services/product";

    export default {
        name: 'Operator',
        props: {
            value: {},
            type:{
                type: Number,
                default: 1
            },
            brandId:{
                type: Object,
                default: () => ({})
            },
            modelId:{
                type: Object,
                default: () => ({})
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            }
        },

        data() {
            return {data: {}, deviceType: []}
        },
        watch: {
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                            this.data = value;
                        } else {
                            this.data = {};
                        }

                }
            },
            modelId:{
                immediate:true,
                handler(modelId){
                    this.deviceType=[]
                    if(modelId.value){
                        console.log("774",modelId)
                         this.loadData();
                    }
                   
                }
            },
        },
        mounted() {
            // this.loadData();
        },
        methods: {
           
            handleChange(value) {
                
                let find = this.deviceType.find((item, i) => {
                    return item.value == value
                })
                if (!find) {
                    find = {};
                }
               
                if (find==undefined) {
                    find = "";
                }
                this.$emit("input", {...find});
                this.$emit("change", {...find});
                this.data = {...find};
            },
            async loadData() {
                this.deviceType=[]
                let searchData={
                    brandId:this.brandId.value?this.brandId.value:'',
                    modelId:this.modelId.value?this.modelId.value:""
                }
                if(searchData.brandId&&searchData.modelId){
                        const response = await EditionfindPage({
                            page: 1,
                            size: 999,
                            type:this.type,
                            ...searchData
                        });
              
                        if (response&&response.code==0) {
                            this.deviceType = response.data.list.map((item, i) => {
                                return {name: item.editionName, value: item.id}
                            })
                        }
                }
               
              
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/deviceModule.vue